export const showJpYen = (value: number) => {
    return new Intl.NumberFormat("ja-JP", {
        style: "currency",
        currency: "JPY"
    })
        .format(value)
        .replace(/^￥/, "¥")
}
